module.exports = __webpack_public_path__ + "img/flagCNY.f4ebd4a3.svg";